import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppStateInterface } from '../../store/state/app.state';
import { uuidSelector } from '../../store/selectors/profile.selectors';

@Injectable({
  providedIn: 'root',
})
export class AuthSupportGuard implements CanActivate {
  private uuid: string = '';

  constructor(private router: Router, private store: Store<AppStateInterface>) {
    combineLatest([this.store.select(uuidSelector)]).subscribe(([uuid]) => {
      this.uuid = uuid;
    });
  }

  canActivate(
    route: ActivatedRouteSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (route.queryParams.eventid && route.queryParams.sourcesite) {
      return true;
    } else if (this.uuid) {
      return true;
    } else {
      this.router.navigate(['/auth/login']);
      return false;
    }
  }
}
